/*
 * File: location.service.ts
 * Project: a-a
 * File Created: Tuesday, 30th September 2025 11:38:34 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 30th September 2025 11:44:25 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';

import { ApiConstants } from './api-constants';
export class LocationService {
  static getAddressSuggestion = async (location: string) => {
    return await (
      await axios.get(ApiConstants.LOCATION.GOOGLE_LOCATION.URL(location))
    ).data;
  };
}
